var _classCallCheck = require("/Users/marcellin.nshimiyimana@ibm.com/profession/contribution/github/nshimiye/react-geojson-editor/packages/react-geojson-editor-demo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/marcellin.nshimiyimana@ibm.com/profession/contribution/github/nshimiye/react-geojson-editor/packages/react-geojson-editor-demo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/marcellin.nshimiyimana@ibm.com/profession/contribution/github/nshimiye/react-geojson-editor/packages/react-geojson-editor-demo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/marcellin.nshimiyimana@ibm.com/profession/contribution/github/nshimiye/react-geojson-editor/packages/react-geojson-editor-demo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/marcellin.nshimiyimana@ibm.com/profession/contribution/github/nshimiye/react-geojson-editor/packages/react-geojson-editor-demo/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/marcellin.nshimiyimana@ibm.com/profession/contribution/github/nshimiye/react-geojson-editor/packages/react-geojson-editor-demo/node_modules/@babel/runtime/helpers/inherits");

var _toConsumableArray = require("/Users/marcellin.nshimiyimana@ibm.com/profession/contribution/github/nshimiye/react-geojson-editor/packages/react-geojson-editor-demo/node_modules/@babel/runtime/helpers/toConsumableArray");

(function (e, t) {
  'object' == typeof exports && 'object' == typeof module ? module.exports = t() : 'function' == typeof define && define.amd ? define('index', [], t) : 'object' == typeof exports ? exports.index = t() : e.index = t();
})('undefined' == typeof self ? this : self, function () {
  return function (e) {
    function t(o) {
      if (n[o]) return n[o].exports;
      var r = n[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, o) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: o
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e['default'];
      } : function () {
        return e;
      };
      return t.d(n, 'a', n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = './', t(t.s = 26);
  }([function (e) {
    e.exports = require('react');
  }, function (e) {
    e.exports = require('prop-types');
  }, function (e, t, n) {
    'use strict';

    function o(_ref) {
      var e = _ref.googleMapURL,
          t = _ref.children,
          n = _ref.center,
          o = _ref.zoom,
          r = _ref.height,
          a = _ref.width;
      return Object(f.createElement)(L, {
        scriptUrl: e
      }, Object(f.createElement)(A, {
        center: n,
        zoom: o,
        height: r,
        width: a
      }, t));
    }

    function r(_ref2) {
      var e = _ref2.google,
          t = _ref2.children,
          n = _ref2.center,
          o = _ref2.zoom,
          r = _ref2.height,
          a = _ref2.width;
      return Object(f.createElement)(C.Provider, {
        value: e
      }, Object(f.createElement)(A, {
        center: n,
        zoom: o,
        height: r,
        width: a
      }, t));
    }

    function a(e) {
      return e[0];
    }

    function i(e) {
      var t = a(e),
          n = e.filter(function (e) {
        return e !== t;
      }).reduce(O.a, t);
      return n;
    }

    function d(e) {
      return Array.isArray(e) ? e : Array.from(e);
    }

    function s(e, t, _ref3) {
      var n = _ref3.google;
      var o = new n.maps.Data.Polygon(e.getPaths().getArray().map(function (e) {
        return e.getArray();
      })),
          r = new n.maps.Data.Feature({
        geometry: o
      });
      return r.toGeoJson(t);
    }

    function l(e, t) {
      return new Promise(function (n) {
        return s(e, n, t);
      });
    }

    function p(e, t) {
      return Promise.all(e.map(function (e) {
        return l(e, t);
      }));
    }

    function g(e, _ref4) {
      var t = _ref4.google;
      if (!e) return null;
      var n = new t.maps.Data();
      return n.addGeoJson(e), n;
    }

    function c(e, _ref5) {
      var t = _ref5.google;
      var n = e.getArray(),
          o = d(n);
      var r = o[0],
          a = o.slice(1),
          i = Object(x.c)(t, r),
          s = new t.maps.Polygon({
        paths: [r.getArray()].concat(_toConsumableArray(a.map(function (e) {
          return i && Object(x.c)(t, e) ? e.getArray().reverse.call(_toConsumableArray(e.getArray())) : e.getArray();
        }))),
        editable: !1,
        clickable: !0
      });
      return s;
    }

    function u(e, t) {
      var n = [];
      return e.forEach(function (e) {
        var o = e.getGeometry();
        var r = [];

        switch (o.getType()) {
          case 'MultiPolygon':
            r = o.getArray().map(function (e) {
              return c(e, t);
            });
            break;

          case 'Polygon':
            r = [c(o, t)];
            break;

          default:
            r = [];
        }

        n = [].concat(_toConsumableArray(n), _toConsumableArray(r));
      }), n;
    }

    function _(e, t) {
      var n = g(e, t);
      var o = u(n, t),
          r = T(o, 1);
      var a = r[0];
      return a;
    }

    function m(e, t, _ref6) {
      var n = _ref6.google;
      var o = new n.maps.Data();
      o.add(new n.maps.Data.Feature({
        geometry: new n.maps.Data.MultiPolygon(e.map(function (e) {
          return e.getPaths().getArray().map(function (e) {
            return e.getArray();
          });
        }))
      }));
      var r = e.reduce(function (e, t) {
        var o = t.getPaths().getArray().map(function (e) {
          return e.getArray();
        }),
            r = T(o, 1);
        var a = r[0],
            i = n.maps.geometry.spherical.computeArea(a);
        return e + i;
      }, 0);
      return o.toGeoJson(function (e) {
        'function' == typeof t && t({
          geojson: e,
          totalArea: r
        });
      });
    }

    function y(e, t) {
      return new Promise(function (n) {
        return m(e, n, t);
      });
    }

    var f = n(0),
        h = n.n(f),
        b = n(1),
        w = n.n(b),
        x = n(5);
    var P = 'NONE',
        E = 'LOADED',
        C = h.a.createContext(null);

    var L =
    /*#__PURE__*/
    function (_f$Component) {
      _inherits(L, _f$Component);

      function L(e) {
        var _this;

        _classCallCheck(this, L);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(L).call(this, e)), Object.defineProperty(_assertThisInitialized(_this), 'state', {
          enumerable: !0,
          writable: !0,
          value: {
            loadingState: P,
            google: null
          }
        }), Object.defineProperty(_assertThisInitialized(_this), 'isUnmounted', {
          enumerable: !0,
          writable: !0,
          value: !1
        }), _this.handleLoaded = _this.handleLoaded.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(L, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          var e = this.props.scriptUrl,
              t = this.state.loadingState;
          t !== P || this.setState({
            loadingState: 'BEGIN'
          }, function () {
            Object(x.b)(e, function () {
              return _this2.handleLoaded(google);
            });
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.isUnmounted = !0;
        }
      }, {
        key: "handleLoaded",
        value: function handleLoaded(e) {
          this.isUnmounted || this.setState({
            google: e,
            loadingState: E
          });
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.state;
          var t = e.google,
              n = e.loadingState;
          return n === E ? t ? Object(f.createElement)(C.Provider, {
            value: t
          }, this.props.children) : Object(f.createElement)('div', null, ' Error Loading Script ') : Object(f.createElement)('div', null, ' Loading ... ');
        }
      }]);

      return L;
    }(f.Component);

    L.propTypes = {
      children: w.a.node.isRequired,
      scriptUrl: w.a.string.isRequired
    };
    var v = h.a.createContext({
      google: null,
      map: null
    });

    var A =
    /*#__PURE__*/
    function (_f$Component2) {
      _inherits(A, _f$Component2);

      function A(e, t) {
        var _this3;

        _classCallCheck(this, A);

        if (_this3 = _possibleConstructorReturn(this, _getPrototypeOf(A).call(this, e, t)), Object.defineProperty(_assertThisInitialized(_this3), 'state', {
          enumerable: !0,
          writable: !0,
          value: {
            google: null,
            map: null
          }
        }), !t) throw new Error('No google object found, please make sure you have loaded google map script');
        _this3.mapElement = h.a.createRef();
        return _possibleConstructorReturn(_this3);
      }

      _createClass(A, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var e = this.props;
          var t = e.center,
              n = e.zoom,
              o = this.context,
              r = new o.maps.Map(this.mapElement.current, {
            center: t,
            zoom: n,
            fullscreenControl: !1,
            streetViewControl: !1,
            mapTypeControlOptions: {
              style: o.maps.MapTypeControlStyle.DROPDOWN_MENU
            }
          });
          this.setState({
            google: o,
            map: r
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(e) {
          var t = this.props.center;
          e.center !== t && this.state.map.setCenter(t);
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props;
          var t = e.width,
              n = e.height,
              o = this.state.map;
          return Object(f.createElement)('div', {
            style: {
              width: t,
              height: n
            },
            ref: this.mapElement
          }, o ? Object(f.createElement)(v.Provider, {
            value: this.state
          }, this.props.children) : null);
        }
      }]);

      return A;
    }(f.Component);

    Object.defineProperty(A, 'contextType', {
      enumerable: !0,
      writable: !0,
      value: C
    }), A.propTypes = {
      center: w.a.shape({
        lat: w.a.number,
        lng: w.a.number
      }).isRequired,
      children: w.a.node.isRequired,
      height: w.a.number.isRequired,
      width: w.a.string.isRequired,
      zoom: w.a.number.isRequired
    };
    o.propTypes = {
      googleMapURL: w.a.string.isRequired,
      children: w.a.node.isRequired,
      center: w.a.shape({
        lat: w.a.number,
        lng: w.a.number
      }).isRequired,
      height: w.a.number.isRequired,
      width: w.a.oneOfType([w.a.string, w.a.number]),
      zoom: w.a.number
    }, r.propTypes = {
      google: w.a.object.isRequired,
      children: w.a.string.isRequired,
      center: w.a.shape({
        lat: w.a.number,
        lng: w.a.number
      }).isRequired,
      height: w.a.number.isRequired,
      width: w.a.oneOfType([w.a.string, w.a.number]),
      zoom: w.a.number
    };
    var S = {
      width: '100%',
      zoom: 5
    };
    o.defaultProps = S, r.defaultProps = S;

    var M = n(19),
        O = n.n(M),
        T = function () {
      function e(e, t) {
        var n = [],
            o = !0,
            r = !1,
            a = void 0;

        try {
          for (var i, d = e[Symbol.iterator](); !(o = (i = d.next()).done) && (n.push(i.value), !(t && n.length === t)); o = !0) {
            ;
          }
        } catch (e) {
          r = !0, a = e;
        } finally {
          try {
            !o && d['return'] && d['return']();
          } finally {
            if (r) throw a;
          }
        }

        return n;
      }

      return function (t, n) {
        if (Array.isArray(t)) return t;
        if (Symbol.iterator in Object(t)) return e(t, n);
        throw new TypeError('Invalid attempt to destructure non-iterable instance');
      };
    }(),
        D = n(6);

    var R = h.a.createContext({
      gmapData: null,
      newPolygonList: [],
      polygonList: [],
      selectedPolygonList: [],
      addNewPolygon: null,
      selectPolygon: null,
      unSelectPolygon: null,
      addAction: null,
      subtractAction: null,
      deleteAction: null,
      centerAction: null,
      discardChanges: null,
      persistChanges: null
    });

    var j =
    /*#__PURE__*/
    function (_f$Component3) {
      _inherits(j, _f$Component3);

      function j(e, t) {
        var _this4;

        _classCallCheck(this, j);

        _this4 = _possibleConstructorReturn(this, _getPrototypeOf(j).call(this, e, t)), _this4.addNewPolygon = _this4.addNewPolygon.bind(_assertThisInitialized(_this4)), _this4.selectPolygon = _this4.selectPolygon.bind(_assertThisInitialized(_this4)), _this4.unSelectPolygon = _this4.unSelectPolygon.bind(_assertThisInitialized(_this4)), _this4.subtractAction = _this4.subtractAction.bind(_assertThisInitialized(_this4)), _this4.deleteAction = _this4.deleteAction.bind(_assertThisInitialized(_this4)), _this4.discardChanges = _this4.discardChanges.bind(_assertThisInitialized(_this4)), _this4.persistChanges = _this4.persistChanges.bind(_assertThisInitialized(_this4));
        var n = e.initialGeojson ? g(e.initialGeojson, t) : null;
        _this4.state = {
          gmapData: n,
          newPolygonList: [],
          polygonList: n ? u(n, t) : [],
          selectedPolygonList: [],
          addNewPolygon: _this4.addNewPolygon,
          selectPolygon: _this4.selectPolygon,
          unSelectPolygon: _this4.unSelectPolygon,
          addAction: null,
          subtractAction: _this4.subtractAction,
          deleteAction: _this4.deleteAction,
          centerAction: null,
          discardChanges: _this4.discardChanges,
          persistChanges: _this4.persistChanges
        };
        return _this4;
      }

      _createClass(j, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(e) {
          var t = this.props.initialGeojson;

          if (e.initialGeojson !== t) {
            var _e = t ? g(t, this.context) : null;

            this.setState({
              gmapData: _e,
              newPolygonList: [],
              polygonList: _e ? u(_e, this.context) : [],
              selectedPolygonList: []
            });
          }
        }
      }, {
        key: "addNewPolygon",
        value: function addNewPolygon(e) {
          this.setState(function (t) {
            return {
              newPolygonList: [].concat(_toConsumableArray(t.newPolygonList), [e]),
              selectedPolygonList: [].concat(_toConsumableArray(t.selectedPolygonList), [e])
            };
          });
        }
      }, {
        key: "selectPolygon",
        value: function selectPolygon(e) {
          this.setState(function (t) {
            return {
              selectedPolygonList: [].concat(_toConsumableArray(t.selectedPolygonList), [e])
            };
          });
        }
      }, {
        key: "unSelectPolygon",
        value: function unSelectPolygon(e) {
          this.setState(function (t) {
            return {
              selectedPolygonList: t.selectedPolygonList.filter(function (t) {
                return t !== e;
              })
            };
          });
        }
      }, {
        key: "subtractAction",
        value: function subtractAction() {
          var _this5 = this;

          p(this.state.selectedPolygonList, this.context).then(function (e) {
            return i(e);
          }).then(function (e) {
            return _(e, _this5.context);
          }).then(function (e) {
            _this5.setState(function (t) {
              return {
                newPolygonList: [].concat(_toConsumableArray(t.newPolygonList.filter(function (e) {
                  return !t.selectedPolygonList.includes(e);
                })), [e]),
                polygonList: t.polygonList.filter(function (e) {
                  return !t.selectedPolygonList.includes(e);
                }),
                selectedPolygonList: []
              };
            });
          });
        }
      }, {
        key: "deleteAction",
        value: function deleteAction() {
          this.setState(function (e) {
            return {
              newPolygonList: e.newPolygonList.filter(function (t) {
                return !e.selectedPolygonList.includes(t);
              }),
              polygonList: e.polygonList.filter(function (t) {
                return !e.selectedPolygonList.includes(t);
              }),
              selectedPolygonList: []
            };
          });
        }
      }, {
        key: "discardChanges",
        value: function discardChanges(e, t) {
          var _this6 = this;

          this.setState(function (e) {
            return {
              newPolygonList: [],
              polygonList: e.gmapData ? u(e.gmapData, _this6.context) : [],
              selectedPolygonList: []
            };
          }, t);
        }
      }, {
        key: "persistChanges",
        value: function persistChanges(e, t) {
          var _this7 = this;

          y([].concat(_toConsumableArray(this.state.newPolygonList), _toConsumableArray(this.state.polygonList)), this.context).then(function (_ref7) {
            var e = _ref7.geojson,
                n = _ref7.totalArea;
            t(), _this7.props.onSave(e, n);
          });
        }
      }, {
        key: "render",
        value: function render() {
          return Object(f.createElement)(R.Provider, {
            value: this.state
          }, this.props.children);
        }
      }]);

      return j;
    }(f.Component);

    Object.defineProperty(j, 'contextType', {
      enumerable: !0,
      writable: !0,
      value: v
    });
    j.propTypes = {
      children: w.a.node.isRequired,
      initialGeojson: D.c,
      onSave: w.a.func
    }, j.defaultProps = {
      initialGeojson: null,
      onSave: function onSave() {}
    }, n.d(t, !1, function () {
      return L;
    }), n.d(t, !1, function () {
      return A;
    }), n.d(t, 'a', function () {
      return v;
    }), n.d(t, !1, function () {}), n.d(t, 'b', function () {
      return o;
    }), n.d(t, 'd', function () {
      return j;
    }), n.d(t, 'c', function () {
      return R;
    });
  }, function (e) {
    function t(e, t) {
      var o = e[1] || '',
          r = e[3];
      if (!r) return o;

      if (t && 'function' == typeof btoa) {
        var a = n(r),
            i = r.sources.map(function (e) {
          return '/*# sourceURL=' + r.sourceRoot + e + ' */';
        });
        return [o].concat(i).concat([a]).join('\n');
      }

      return [o].join('\n');
    }

    function n(e) {
      var t = btoa(unescape(encodeURIComponent(JSON.stringify(e))));
      return '/*# ' + ('sourceMappingURL=data:application/json;charset=utf-8;base64,' + t) + ' */';
    }

    e.exports = function (e) {
      var n = [];
      return n.toString = function () {
        return this.map(function (n) {
          var o = t(n, e);
          return n[2] ? '@media ' + n[2] + '{' + o + '}' : o;
        }).join('');
      }, n.i = function (e, t) {
        'string' == typeof e && (e = [[null, e, '']]);

        for (var o, r = {}, a = 0; a < this.length; a++) {
          o = this[a][0], 'number' == typeof o && (r[o] = !0);
        }

        for (a = 0; a < e.length; a++) {
          var i = e[a];
          'number' == typeof i[0] && r[i[0]] || (t && !i[2] ? i[2] = t : t && (i[2] = '(' + i[2] + ') and (' + t + ')'), n.push(i));
        }
      }, n;
    };
  }, function (e, t, n) {
    function o(e, t) {
      for (var n = 0; n < e.length; n++) {
        var o = e[n],
            r = _[o.id];

        if (r) {
          r.refs++;

          for (var a = 0; a < r.parts.length; a++) {
            r.parts[a](o.parts[a]);
          }

          for (; a < o.parts.length; a++) {
            r.parts.push(p(o.parts[a], t));
          }
        } else {
          for (var i = [], a = 0; a < o.parts.length; a++) {
            i.push(p(o.parts[a], t));
          }

          _[o.id] = {
            id: o.id,
            refs: 1,
            parts: i
          };
        }
      }
    }

    function r(e, t) {
      for (var n = [], o = {}, r = 0; r < e.length; r++) {
        var a = e[r],
            i = t.base ? a[0] + t.base : a[0],
            d = a[1],
            s = a[2],
            l = a[3],
            p = {
          css: d,
          media: s,
          sourceMap: l
        };
        o[i] ? o[i].parts.push(p) : n.push(o[i] = {
          id: i,
          parts: [p]
        });
      }

      return n;
    }

    function a(e, t) {
      var n = f(e.insertInto);
      if (!n) throw new Error('Couldn\'t find a style target. This probably means that the value for the \'insertInto\' parameter is invalid.');
      var o = w[w.length - 1];
      if ('top' === e.insertAt) o ? o.nextSibling ? n.insertBefore(t, o.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), w.push(t);else if ('bottom' === e.insertAt) n.appendChild(t);else if ('object' == typeof e.insertAt && e.insertAt.before) {
        var r = f(e.insertInto + ' ' + e.insertAt.before);
        n.insertBefore(t, r);
      } else throw new Error('[Style Loader]\n\n Invalid value for parameter \'insertAt\' (\'options.insertAt\') found.\n Must be \'top\', \'bottom\', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n');
    }

    function i(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var t = w.indexOf(e);
      0 <= t && w.splice(t, 1);
    }

    function d(e) {
      var t = document.createElement('style');
      return e.attrs.type = 'text/css', l(t, e.attrs), a(e, t), t;
    }

    function s(e) {
      var t = document.createElement('link');
      return e.attrs.type = 'text/css', e.attrs.rel = 'stylesheet', l(t, e.attrs), a(e, t), t;
    }

    function l(e, t) {
      Object.keys(t).forEach(function (n) {
        e.setAttribute(n, t[n]);
      });
    }

    function p(e, t) {
      var n, o, r, a;
      if (t.transform && e.css) if (a = t.transform(e.css), a) e.css = a;else return function () {};

      if (t.singleton) {
        var l = b++;
        n = h || (h = d(t)), o = g.bind(null, n, l, !1), r = g.bind(null, n, l, !0);
      } else e.sourceMap && 'function' == typeof URL && 'function' == typeof URL.createObjectURL && 'function' == typeof URL.revokeObjectURL && 'function' == typeof Blob && 'function' == typeof btoa ? (n = s(t), o = u.bind(null, n, t), r = function r() {
        i(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = d(t), o = c.bind(null, n), r = function r() {
        i(n);
      });

      return o(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          o(e = t);
        } else r();
      };
    }

    function g(e, t, n, o) {
      var r = n ? '' : o.css;
      if (e.styleSheet) e.styleSheet.cssText = P(t, r);else {
        var a = document.createTextNode(r),
            i = e.childNodes;
        i[t] && e.removeChild(i[t]), i.length ? e.insertBefore(a, i[t]) : e.appendChild(a);
      }
    }

    function c(e, t) {
      var n = t.css,
          o = t.media;
      if (o && e.setAttribute('media', o), e.styleSheet) e.styleSheet.cssText = n;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(n));
      }
    }

    function u(e, t, n) {
      var o = n.css,
          r = n.sourceMap,
          a = t.convertToAbsoluteUrls === void 0 && r;
      (t.convertToAbsoluteUrls || a) && (o = x(o)), r && (o += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + ' */');
      var i = new Blob([o], {
        type: 'text/css'
      }),
          d = e.href;
      e.href = URL.createObjectURL(i), d && URL.revokeObjectURL(d);
    }

    var _ = {},
        m = function (e) {
      var t;
      return function () {
        return 'undefined' == typeof t && (t = e.apply(this, arguments)), t;
      };
    }(function () {
      return window && document && document.all && !window.atob;
    }),
        y = function y(e) {
      return document.querySelector(e);
    },
        f = function () {
      var e = {};
      return function (t) {
        if ('function' == typeof t) return t();

        if ('undefined' == typeof e[t]) {
          var n = y.call(this, t);
          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (t) {
            n = null;
          }
          e[t] = n;
        }

        return e[t];
      };
    }(),
        h = null,
        b = 0,
        w = [],
        x = n(9);

    e.exports = function (e, t) {
      if ('undefined' != typeof DEBUG && DEBUG && 'object' != typeof document) throw new Error('The style-loader cannot be used in a non-browser environment');
      t = t || {}, t.attrs = 'object' == typeof t.attrs ? t.attrs : {}, t.singleton || 'boolean' == typeof t.singleton || (t.singleton = m()), t.insertInto || (t.insertInto = 'head'), t.insertAt || (t.insertAt = 'bottom');
      var n = r(e, t);
      return o(n, t), function (e) {
        for (var a = [], d = 0; d < n.length; d++) {
          var i = n[d],
              s = _[i.id];
          s.refs--, a.push(s);
        }

        if (e) {
          var l = r(e, t);
          o(l, t);
        }

        for (var s, d = 0; d < a.length; d++) {
          if (s = a[d], 0 === s.refs) {
            for (var p = 0; p < s.parts.length; p++) {
              s.parts[p]();
            }

            delete _[s.id];
          }
        }
      };
    };

    var P = function () {
      var e = [];
      return function (t, n) {
        return e[t] = n, e.filter(Boolean).join('\n');
      };
    }();
  }, function (e, t, n) {
    'use strict';

    t.c = function (e, t) {
      var n = t.getArray(),
          o = e.maps.geometry.spherical.computeSignedArea(n);
      return 0 < o;
    }, t.b = function (e, t, n) {
      try {
        r()(e, t);
      } catch (e) {
        n(e);
      }
    };
    var o = n(18),
        r = n.n(o);
    t.a = {
      CREATE: 'CREATE',
      EDIT: 'EDIT',
      VIEW: 'VIEW',
      DELETE: 'DELETE'
    };
  }, function (e, t) {
    'use strict';

    t.a = function (e, t, n) {
      if (!e[t]) return new Error("Invalid prop `".concat(t, "` supplied to") + " `".concat(n, "`. Validation failed."));
    }, t.b = function (e, t, n) {
      if (!e[t]) return new Error("Invalid prop `".concat(t, "` supplied to") + " `".concat(n, "`. Validation failed."));
    }, t.c = function (e, t, n) {
      if (!e[t]) return new Error("Invalid prop `".concat(t, "` supplied to") + " `".concat(n, "`. Validation failed."));
    };
  }, function (e, t, n) {
    'use strict';

    function o(e, t) {
      var n = {};

      for (var o in e) {
        0 <= t.indexOf(o) || Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
      }

      return n;
    }

    Object.defineProperty(t, '__esModule', {
      value: !0
    });

    var r = n(0),
        a = n.n(r),
        i = n(1),
        d = n.n(i),
        s = n(10),
        l = n.n(s),
        p = Object.assign || function (e) {
      for (var t, n = 1; n < arguments.length; n++) {
        for (var o in t = arguments[n], t) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }

      return e;
    };

    var g = function g(e) {
      var t = e.children,
          n = o(e, ['children']);
      return Object(r.createElement)('button', p({
        className: l.a.button
      }, n), t);
    };

    g.propTypes = {
      children: d.a.string
    }, g.defaultProps = {
      children: 'Button'
    };
    n.d(t, 'Button', function () {
      return g;
    });
    t['default'] = g;
  }, function (e, t, n) {
    'use strict';

    Object.defineProperty(t, '__esModule', {
      value: !0
    });
    var o = n(0),
        r = n.n(o),
        a = n(1),
        i = n.n(a),
        d = n(12),
        s = n.n(d),
        l = n(13),
        p = n.n(l);

    var g =
    /*#__PURE__*/
    function (_o$Component) {
      _inherits(g, _o$Component);

      function g(e) {
        var _this8;

        _classCallCheck(this, g);

        _this8 = _possibleConstructorReturn(this, _getPrototypeOf(g).call(this, e)), Object.defineProperty(_assertThisInitialized(_this8), 'state', {
          enumerable: !0,
          writable: !0,
          value: {
            open: _this8.props.openAtStart
          }
        }), _this8.onBlurClose = _this8.onBlurClose.bind(_assertThisInitialized(_this8)), _this8.toggleOpen = _this8.toggleOpen.bind(_assertThisInitialized(_this8)), _this8.renderContent = _this8.renderContent.bind(_assertThisInitialized(_this8));
        return _this8;
      }

      _createClass(g, [{
        key: "onBlurClose",
        value: function onBlurClose() {
          this.setState({
            open: !1
          });
        }
      }, {
        key: "toggleOpen",
        value: function toggleOpen(t) {
          t.preventDefault();
          var e = this.props.children;
          this.setState({
            open: !this.state.open && !!o.Children.count(e)
          });
        }
      }, {
        key: "renderContent",
        value: function renderContent(e) {
          return Object(o.createElement)('div', {
            className: p.a.dropdownBody
          }, e);
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.state.open;
          var t = this.props;
          var n = t.children,
              r = t.name,
              a = t.positionRight,
              i = t.style,
              d = t.containerStyle;
          return Object(o.createElement)('div', {
            className: a ? s()(p.a.mlDropdown, p.a.rightPosition) : p.a.mlDropdown,
            style: i
          }, Object(o.createElement)('div', {
            className: p.a.dropdownContainer,
            style: d
          }, Object(o.createElement)('div', {
            className: e ? s()(p.a.dropdownButton, p.a.open) : p.a.dropdownButton,
            tabIndex: '0',
            onClick: this.toggleOpen
          }, r), e && this.renderContent(n)));
        }
      }]);

      return g;
    }(o.Component);

    g.propTypes = {
      children: i.a.oneOfType([i.a.node, i.a.func, i.a.arrayOf(i.a.node)]).isRequired,
      name: i.a.string,
      style: i.a.object,
      containerStyle: i.a.object
    }, g.defaultProps = {
      name: 'Dropdown',
      style: {},
      containerStyle: {}
    };

    var c = g,
        u = function u(e, t, n) {
      e('Dropdown', t).addDecorator(n).add('with required props', function () {
        return Object(o.createElement)(c, {
          name: 'Customize View'
        }, Object(o.createElement)('div', {
          style: {
            padding: 0,
            height: 250
          }
        }, ' Child Component '));
      }).add('with right positioning prop', function () {
        return Object(o.createElement)(c, {
          name: 'Customize View',
          positionRight: !0
        }, Object(o.createElement)('div', {
          style: {
            padding: 20,
            height: 250
          }
        }, ' Child Component '));
      }).add('with default props', function () {
        return Object(o.createElement)(c, null);
      });
    };

    n.d(t, 'Dropdown', function () {
      return g;
    }), n.d(t, 'DropdownStory', function () {
      return u;
    });
    t['default'] = c;
  }, function (e) {
    e.exports = function (e) {
      var t = 'undefined' != typeof window && window.location;
      if (!t) throw new Error('fixUrls requires window.location');
      if (!e || 'string' != typeof e) return e;
      var n = t.protocol + '//' + t.host,
          o = n + t.pathname.replace(/\/[^\/]*$/, '/'),
          r = e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
        var r = t.trim().replace(/^"(.*)"$/, function (e, t) {
          return t;
        }).replace(/^'(.*)'$/, function (e, t) {
          return t;
        });
        if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(r)) return e;
        var a;
        return a = 0 === r.indexOf('//') ? r : 0 === r.indexOf('/') ? n + r : o + r.replace(/^\.\//, ''), 'url(' + JSON.stringify(a) + ')';
      });
      return r;
    };
  }, function (e, t, n) {
    var o = n(11);
    'string' == typeof o && (o = [[e.i, o, '']]);
    var r,
        a = {
      hmr: !0
    };
    a.transform = r, a.insertInto = void 0;
    n(4)(o, a);
    o.locals && (e.exports = o.locals), !1;
  }, function (e, t, n) {
    t = e.exports = n(3)(!1), t.push([e.i, '.rge__styles__button___127GD {\n  outline: none;\n  cursor: pointer;\n  display: inline-block;\n  width: 100%;\n  background: #FFFFFF;\n  border: none;\n  border-bottom: 1px solid #d4d6d8;\n  border-radius: 0;\n  font-size: 13px;\n  line-height: 17px;\n  color: #333333;\n  text-align: left;\n  padding: 10px;\n  position: relative;\n  top: 1px; }\n  .rge__styles__button___127GD:disabled {\n    opacity: 0.5; }\n', '']), t.locals = {
      button: 'rge__styles__button___127GD'
    };
  }, function (e) {
    e.exports = require('classnames');
  }, function (e, t, n) {
    var o = n(14);
    'string' == typeof o && (o = [[e.i, o, '']]);
    var r,
        a = {
      hmr: !0
    };
    a.transform = r, a.insertInto = void 0;
    n(4)(o, a);
    o.locals && (e.exports = o.locals), !1;
  }, function (e, t, n) {
    t = e.exports = n(3)(!1), t.push([e.i, '.rge__styles__ml-dropdown___1O68P {\n  position: relative;\n  padding-top: 20px;\n  padding-bottom: 20px; }\n\n.rge__styles__ml-dropdown___1O68P.rge__styles__right-position___BH_Jl {\n  display: flex;\n  justify-content: flex-end; }\n\n.rge__styles__ml-dropdown___1O68P .rge__styles__dropdown-container___3Ao7x {\n  position: relative;\n  width: 250px;\n  bottom: 1px; }\n\n.rge__styles__ml-dropdown___1O68P .rge__styles__dropdown-container___3Ao7x .rge__styles__dropdown-button___3C2of {\n  outline: none;\n  cursor: pointer;\n  display: inline-block;\n  width: calc(100% - 20px);\n  height: inherit;\n  background: #FFFFFF;\n  border: none;\n  box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 6px;\n  border-radius: 2px;\n  font-family: \'Noto Sans\', sans-serif;\n  font-size: 13px;\n  line-height: 17px;\n  color: #333333;\n  text-align: left;\n  padding: 10px;\n  position: relative;\n  top: 1px;\n  /* Dropdown box downwards arrow style */ }\n  .rge__styles__ml-dropdown___1O68P .rge__styles__dropdown-container___3Ao7x .rge__styles__dropdown-button___3C2of:after {\n    content: "";\n    width: 0;\n    height: 0;\n    border: 7px solid transparent;\n    border-color: #AAA9AA transparent transparent transparent;\n    position: absolute;\n    top: 16px;\n    right: 10px; }\n  .rge__styles__ml-dropdown___1O68P .rge__styles__dropdown-container___3Ao7x .rge__styles__dropdown-button___3C2of.rge__styles__open___2Zl2x {\n    position: relative;\n    font-weight: bold;\n    border: none;\n    outline: 0; }\n  .rge__styles__ml-dropdown___1O68P .rge__styles__dropdown-container___3Ao7x .rge__styles__dropdown-button___3C2of.rge__styles__open___2Zl2x:after {\n    border-color: #000000 transparent transparent transparent; }\n\n.rge__styles__ml-dropdown___1O68P .rge__styles__dropdown-container___3Ao7x .rge__styles__dropdown-body___1Qb6u {\n  position: absolute;\n  left: 0;\n  margin-top: 2px;\n  width: 100%;\n  background: #FFFFFF;\n  border: none;\n  border-radius: 2px;\n  z-index: 1000;\n  padding: 0;\n  box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 6px; }\n\n.rge__styles__ml-dropdown___1O68P .rge__styles__dropdown-container___3Ao7x .rge__styles__dropdown-main___1oHXz {\n  position: absolute;\n  right: 0;\n  /* must be changed in use */\n  height: 379px;\n  width: 677px;\n  background: #FFFFFF;\n  border: 1px solid #007ABC;\n  border-radius: 2px;\n  display: none;\n  grid-template-columns: 30% 30% 40%;\n  padding-top: 20px;\n  z-index: 1000; }\n  .rge__styles__ml-dropdown___1O68P .rge__styles__dropdown-container___3Ao7x .rge__styles__dropdown-main___1oHXz.rge__styles__open___2Zl2x {\n    display: grid; }\n', '']), t.locals = {
      "ml-dropdown": 'rge__styles__ml-dropdown___1O68P',
      mlDropdown: 'rge__styles__ml-dropdown___1O68P',
      "right-position": 'rge__styles__right-position___BH_Jl',
      rightPosition: 'rge__styles__right-position___BH_Jl',
      "dropdown-container": 'rge__styles__dropdown-container___3Ao7x',
      dropdownContainer: 'rge__styles__dropdown-container___3Ao7x',
      "dropdown-button": 'rge__styles__dropdown-button___3C2of',
      dropdownButton: 'rge__styles__dropdown-button___3C2of',
      open: 'rge__styles__open___2Zl2x',
      "dropdown-body": 'rge__styles__dropdown-body___1Qb6u',
      dropdownBody: 'rge__styles__dropdown-body___1Qb6u',
      "dropdown-main": 'rge__styles__dropdown-main___1oHXz',
      dropdownMain: 'rge__styles__dropdown-main___1oHXz'
    };
  }, function (e, t, n) {
    'use strict';

    (function (e) {
      var o = n(0),
          r = n.n(o),
          a = n(1),
          i = n.n(a),
          d = n(2),
          s = n(5),
          l = n(6),
          p = n(20),
          g = n(21),
          c = n(22);

      var u =
      /*#__PURE__*/
      function (_o$Component2) {
        _inherits(u, _o$Component2);

        function u() {
          var _getPrototypeOf2;

          var _this9;

          _classCallCheck(this, u);

          var t;

          for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
            e[_key] = arguments[_key];
          }

          return _possibleConstructorReturn(_this9, (t = _this9 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(u)).call.apply(_getPrototypeOf2, [this].concat(e))), Object.defineProperty(_assertThisInitialized(_this9), 'state', {
            enumerable: !0,
            writable: !0,
            value: {
              controlMode: s.a.VIEW
            }
          }), t));
        }

        _createClass(u, [{
          key: "render",
          value: function render() {
            var _this10 = this;

            var e = this.props;
            var t = e.center,
                n = e.zoom,
                r = e.onSave,
                a = e.onDelete,
                i = e.existingPolygons,
                l = e.mapHeight,
                u = e.mapWidth,
                _ = this.state.controlMode;
            return Object(o.createElement)('div', {
              style: {
                position: 'relative'
              }
            }, Object(o.createElement)(d.b, {
              googleMapURL: "https://maps.googleapis.com/maps/api/js?key=".concat(this.props.googleMapKey, "&v=3.exp&libraries=geometry,drawing,places"),
              center: t,
              zoom: n,
              height: l,
              width: u
            }, Object(o.createElement)(d.d, {
              initialGeojson: i,
              onSave: r,
              onDelete: a
            }, Object(o.createElement)(p.a, {
              mode: _,
              onToggleMode: function onToggleMode(e) {
                return _this10.setState({
                  controlMode: e
                });
              }
            }), _ === s.a.EDIT && Object(o.createElement)(p.b, null), _ === s.a.EDIT ? Object(o.createElement)(g.a, null) : Object(o.createElement)(c.a, null))));
          }
        }]);

        return u;
      }(o.Component);

      t.a = u, t.b = u, u.propTypes = {
        center: i.a.shape({
          lng: i.a.number,
          lat: i.a.number
        }),
        zoom: i.a.number,
        googleMapKey: i.a.string,
        existingPolygons: l.c,
        onDelete: i.a.func,
        onSave: i.a.func,
        mapHeight: i.a.number,
        mapWidth: i.a.oneOfType([i.a.string, i.a.number])
      }, u.defaultProps = {
        center: {
          lng: -73.945,
          lat: 40.674
        },
        zoom: 5,
        existingPolygons: null,
        googleMapKey: e.env.GOOGLE_MAP_KEY,
        mapHeight: 500,
        mapWidth: '100%',
        onDelete: function onDelete() {},
        onSave: function onSave() {}
      };
    }).call(t, n(17));
  }, function (e, t, n) {
    'use strict';

    Object.defineProperty(t, '__esModule', {
      value: !0
    });
    var o = n(15);
    n.d(t, 'GeoJsonEditor', function () {
      return o.a;
    }), t['default'] = o.b;
  }, function (e) {
    function t() {
      throw new Error('setTimeout has not been defined');
    }

    function n() {
      throw new Error('clearTimeout has not been defined');
    }

    function o(e) {
      if (l === setTimeout) return setTimeout(e, 0);
      if ((l === t || !l) && setTimeout) return l = setTimeout, setTimeout(e, 0);

      try {
        return l(e, 0);
      } catch (t) {
        try {
          return l.call(null, e, 0);
        } catch (t) {
          return l.call(this, e, 0);
        }
      }
    }

    function r(e) {
      if (p === clearTimeout) return clearTimeout(e);
      if ((p === n || !p) && clearTimeout) return p = clearTimeout, clearTimeout(e);

      try {
        return p(e);
      } catch (t) {
        try {
          return p.call(null, e);
        } catch (t) {
          return p.call(this, e);
        }
      }
    }

    function a() {
      _ && c && (_ = !1, c.length ? u = c.concat(u) : m = -1, u.length && d());
    }

    function d() {
      if (!_) {
        var e = o(a);
        _ = !0;

        for (var t = u.length; t;) {
          for (c = u, u = []; ++m < t;) {
            c && c[m].run();
          }

          m = -1, t = u.length;
        }

        c = null, _ = !1, r(e);
      }
    }

    function s(e, t) {
      this.fun = e, this.array = t;
    }

    function i() {}

    var l,
        p,
        g = e.exports = {};

    (function () {
      try {
        l = 'function' == typeof setTimeout ? setTimeout : t;
      } catch (n) {
        l = t;
      }

      try {
        p = 'function' == typeof clearTimeout ? clearTimeout : n;
      } catch (t) {
        p = n;
      }
    })();

    var c,
        u = [],
        _ = !1,
        m = -1;

    g.nextTick = function (e) {
      var t = Array(arguments.length - 1);
      if (1 < arguments.length) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      u.push(new s(e, t)), 1 !== u.length || _ || o(d);
    }, s.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, g.title = 'browser', g.browser = !0, g.env = {}, g.argv = [], g.version = '', g.versions = {}, g.on = i, g.addListener = i, g.once = i, g.off = i, g.removeListener = i, g.removeAllListeners = i, g.emit = i, g.prependListener = i, g.prependOnceListener = i, g.listeners = function () {
      return [];
    }, g.binding = function () {
      throw new Error('process.binding is not supported');
    }, g.cwd = function () {
      return '/';
    }, g.chdir = function () {
      throw new Error('process.chdir is not supported');
    }, g.umask = function () {
      return 0;
    };
  }, function (e) {
    e.exports = require('scriptjs');
  }, function (e) {
    e.exports = require('@turf/difference');
  }, function (e, t, n) {
    'use strict';

    function o(_ref8) {
      var e = _ref8.children;
      return Object(r.createElement)('div', {
        style: c({}, _, {
          textAlign: 'center'
        })
      }, e);
    }

    var r = n(0),
        a = n.n(r),
        i = n(1),
        d = n.n(i),
        s = n(5),
        l = n(8),
        p = n(7),
        g = n(2),
        c = Object.assign || function (e) {
      for (var t, n = 1; n < arguments.length; n++) {
        for (var o in t = arguments[n], t) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }

      return e;
    };

    var u =
    /*#__PURE__*/
    function (_r$Component) {
      _inherits(u, _r$Component);

      function u() {
        var _getPrototypeOf3;

        var _this11;

        _classCallCheck(this, u);

        var t;

        for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          e[_key2] = arguments[_key2];
        }

        return _possibleConstructorReturn(_this11, (t = _this11 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(u)).call.apply(_getPrototypeOf3, [this].concat(e))), Object.defineProperty(_assertThisInitialized(_this11), 'gmapControls', {
          enumerable: !0,
          writable: !0,
          value: null
        }), Object.defineProperty(_assertThisInitialized(_this11), 'gmapControl', {
          enumerable: !0,
          writable: !0,
          value: null
        }), Object.defineProperty(_assertThisInitialized(_this11), 'controlId', {
          enumerable: !0,
          writable: !0,
          value: "gmap-control-".concat(Math.random().toFixed(5).replace('0.', ''))
        }), Object.defineProperty(_assertThisInitialized(_this11), 'controlRef', {
          enumerable: !0,
          writable: !0,
          value: a.a.createRef()
        }), t));
      }

      _createClass(u, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var e = this.context;
          var t = e.map,
              n = e.google;
          this.gmapControls = t.controls[n.maps.ControlPosition.TOP_RIGHT], this.gmapControl = this.controlRef.current.firstChild, this.gmapControls.push(this.gmapControl);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          var e = this.gmapControls.indexOf(this.gmapControl);
          0 <= e && this.gmapControls.removeAt(e);
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props.children;
          return Object(r.createElement)('div', {
            ref: this.controlRef,
            style: {
              display: 'none'
            }
          }, Object(r.createElement)('div', {
            id: this.controlId
          }, Object(r.createElement)(o, null, e)));
        }
      }]);

      return u;
    }(r.Component);

    Object.defineProperty(u, 'contextType', {
      enumerable: !0,
      writable: !0,
      value: g.a
    });

    var _ = {
      backgroundColor: '#fff',
      border: 'none',
      borderRadius: '0',
      boxShadow: 'none',
      cursor: 'pointer',
      marginTop: '10px',
      marginRight: '10px',
      marginBottom: '22px'
    },
        m = function m(_ref9) {
      var e = _ref9.mode,
          t = _ref9.onToggleMode;
      return Object(r.createElement)(u, {
        title: 'Managing geojson changes'
      }, e === s.a.VIEW ? Object(r.createElement)(p.Button, {
        onClick: function onClick() {
          return t(s.a.EDIT);
        },
        style: {
          width: 120,
          boxShadow: 'rgba(0, 0, 0, 0.3) 0px 2px 6px',
          borderRadius: 2
        },
        title: 'Turn on Edit mode'
      }, 'Create / Edit') : Object(r.createElement)(l.Dropdown, {
        name: 'Changes',
        openAtStart: !0,
        style: {
          padding: 0
        },
        containerStyle: {
          width: 120
        }
      }, Object(r.createElement)(g.c.Consumer, null, function (_ref10) {
        var e = _ref10.discardChanges,
            n = _ref10.persistChanges;
        return Object(r.createElement)('div', {
          style: {
            padding: 0
          },
          title: 'GeoJsonControls'
        }, Object(r.createElement)(p.Button, {
          onClick: function onClick(e) {
            n(e, function () {
              return t(s.a.VIEW);
            });
          },
          title: 'Save changes'
        }, 'Save'), Object(r.createElement)(p.Button, {
          onClick: function onClick(n) {
            return e(n, function () {
              return t(s.a.VIEW);
            });
          },
          title: 'Discard changes'
        }, 'Cancel'));
      })));
    };

    m.propTypes = {
      mode: d.a.string,
      onToggleMode: d.a.func
    }, m.defaultProps = {
      mode: s.a.VIEW,
      onToggleMode: function onToggleMode() {}
    };

    var y = function y() {
      return Object(r.createElement)(u, {
        title: 'Managing polygon edits'
      }, Object(r.createElement)(g.c.Consumer, null, function (_ref11) {
        var e = _ref11.selectedPolygonList,
            t = _ref11.subtractAction,
            n = _ref11.deleteAction;
        var o = e.length;
        return Object(r.createElement)(l.Dropdown, {
          name: "".concat(o, " Selected"),
          style: {
            padding: 0
          },
          containerStyle: {
            width: 120
          }
        }, Object(r.createElement)('div', {
          style: {
            padding: 0
          },
          title: 'EditorControls'
        }, Object(r.createElement)(p.Button, {
          disabled: 2 > o,
          onClick: t,
          title: 'Make Hollow'
        }, 'Subtract'), Object(r.createElement)(p.Button, {
          disabled: 0 >= o,
          onClick: n
        }, 'Delete')));
      }));
    };

    n.d(t, 'a', function () {
      return m;
    }), n.d(t, 'b', function () {
      return y;
    });
  }, function (e, t, n) {
    'use strict';

    function o(e, _ref12) {
      var t = _ref12.onSelect,
          n = _ref12.onUnSelect;
      e.addListener('click', function () {
        console.log('addListener', e), e.setEditable(!e.getEditable()), e.getEditable() ? t(e) : n(e);
      });
    }

    function r(e, _ref13) {
      var t = _ref13.google;
      t.maps.event.clearInstanceListeners(e);
    }

    var a = n(0),
        i = n.n(a),
        d = n(2);

    var s =
    /*#__PURE__*/
    function (_a$Component) {
      _inherits(s, _a$Component);

      function s() {
        var _getPrototypeOf4;

        var _this12;

        _classCallCheck(this, s);

        var t;

        for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          e[_key3] = arguments[_key3];
        }

        return _possibleConstructorReturn(_this12, (t = _this12 = _possibleConstructorReturn(this, (_getPrototypeOf4 = _getPrototypeOf(s)).call.apply(_getPrototypeOf4, [this].concat(e))), Object.defineProperty(_assertThisInitialized(_this12), 'drawingManager', {
          enumerable: !0,
          writable: !0,
          value: null
        }), t));
      }

      _createClass(s, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var e = this.context;
          var t = e.map,
              n = e.google,
              o = this.props.onCreate;
          this.drawingManager = new n.maps.drawing.DrawingManager({
            drawingMode: n.maps.drawing.OverlayType.POLYGON,
            drawingControl: !0,
            drawingControlOptions: {
              position: n.maps.ControlPosition.TOP_CENTER,
              drawingModes: [n.maps.drawing.OverlayType.POLYGON]
            },
            polygonOptions: {
              fillColor: '#455A64',
              fillOpacity: 0.3,
              strokeColor: '#455A64',
              strokeWeight: 3,
              clickable: !0,
              editable: !0,
              zIndex: 1
            }
          }), this.drawingManager.addListener('polygoncomplete', function (e) {
            e.setMap(null), o(e);
          }), this.drawingManager.setMap(t);
        }
      }, {
        key: "componentDidUpdatesaved",
        value: function componentDidUpdatesaved() {
          var e = this.context;
          var t = e.map,
              n = e.google,
              o = this.props.onCreate;
          this.drawingManager = new n.maps.drawing.DrawingManager({
            drawingMode: n.maps.drawing.OverlayType.POLYGON,
            drawingControl: !0,
            drawingControlOptions: {
              position: n.maps.ControlPosition.TOP_CENTER,
              drawingModes: [n.maps.drawing.OverlayType.POLYGON]
            },
            polygonOptions: {
              fillColor: '#455A64',
              fillOpacity: 0.3,
              strokeColor: '#455A64',
              strokeWeight: 3,
              clickable: !0,
              editable: !0,
              zIndex: 1
            }
          }), this.drawingManager.addListener('polygoncomplete', function (e) {
            e.setMap(null), o(e);
          }), this.drawingManager.setMap(t);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.drawingManager.setMap(null);
        }
      }, {
        key: "render",
        value: function render() {
          return null;
        }
      }]);

      return s;
    }(a.Component);

    Object.defineProperty(s, 'contextType', {
      enumerable: !0,
      writable: !0,
      value: d.a
    });
    var l = n(1),
        p = n.n(l),
        g = n(6);

    var c =
    /*#__PURE__*/
    function (_a$Component2) {
      _inherits(c, _a$Component2);

      function c(e, t) {
        var _this13;

        _classCallCheck(this, c);

        _this13 = _possibleConstructorReturn(this, _getPrototypeOf(c).call(this, e, t)), console.log('[GeoJsonViewer] map', _this13.context.map);
        return _this13;
      }

      _createClass(c, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var e = this.context.map;
          var t = this.props;
          var n = t.onSelect,
              r = t.onUnSelect,
              a = t.polygons;
          a.forEach(function (t) {
            o(t, {
              onSelect: n,
              onUnSelect: r
            }), t.setMap(e);
          }), this.props.newPolygonList.forEach(function (t) {
            o(t, {
              onSelect: n,
              onUnSelect: r
            }), t.setMap(e);
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(e) {
          var _this14 = this;

          var t = this.context.map;
          var n = this.props;
          var a = n.onSelect,
              i = n.onUnSelect,
              d = n.polygons,
              s = n.newPolygonList;
          e.polygons.forEach(function (e) {
            r(e, _this14.context), e.setMap(null);
          }), e.newPolygonList.forEach(function (e) {
            r(e, _this14.context), e.setMap(null);
          }), d.forEach(function (e) {
            o(e, {
              onSelect: a,
              onUnSelect: i
            }), e.setMap(t);
          }), s.forEach(function (e) {
            o(e, {
              onSelect: a,
              onUnSelect: i
            }), e.setMap(t);
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          var _this15 = this;

          this.props.polygons.forEach(function (e) {
            r(e, _this15.context), e.setMap(null);
          }), this.props.newPolygonList.forEach(function (e) {
            r(e, _this15.context), e.setMap(null);
          });
        }
      }, {
        key: "render",
        value: function render() {
          return null;
        }
      }]);

      return c;
    }(a.Component);

    Object.defineProperty(c, 'contextType', {
      enumerable: !0,
      writable: !0,
      value: d.a
    }), Object.defineProperty(c, 'propTypes', {
      enumerable: !0,
      writable: !0,
      value: {
        polygons: p.a.arrayOf(g.b),
        newPolygonList: p.a.arrayOf(g.b),
        onMount: p.a.func,
        onSelect: p.a.func,
        onUnSelect: p.a.func
      }
    }), Object.defineProperty(c, 'defaultTypes', {
      enumerable: !0,
      writable: !0,
      value: {
        polygons: [],
        newPolygonList: []
      }
    });

    var u = function u() {
      return Object(a.createElement)(d.c.Consumer, null, function (_ref14) {
        var e = _ref14.newPolygonList,
            t = _ref14.polygonList,
            n = _ref14.selectPolygon,
            o = _ref14.unSelectPolygon,
            r = _ref14.addNewPolygon;
        return Object(a.createElement)(i.a.Fragment, null, Object(a.createElement)(s, {
          onCreate: r
        }), Object(a.createElement)(c, {
          newPolygonList: e,
          polygons: t,
          onSelect: n,
          onUnSelect: o
        }));
      });
    };

    n.d(t, 'a', function () {
      return u;
    });
  }, function (e, t, n) {
    'use strict';

    var o = n(0),
        r = n.n(o),
        a = n(1),
        i = n.n(a),
        d = n(2),
        s = n(6);

    var l =
    /*#__PURE__*/
    function (_o$Component3) {
      _inherits(l, _o$Component3);

      function l() {
        _classCallCheck(this, l);

        return _possibleConstructorReturn(this, _getPrototypeOf(l).apply(this, arguments));
      }

      _createClass(l, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (!this.props.gmapData) return;
          var e = this.context.map;
          this.props.gmapData.setMap(e), this.props.newPolygonList.forEach(function (t) {
            return t.setMap(e);
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(e) {
          var t = this.context.map;
          var n = this.props;
          var o = n.gmapData,
              r = n.newPolygonList;
          e.gmapData !== o && (e.gmapData && e.gmapData.setMap(null), o && o.setMap(t)), e.newPolygonList !== r && (e.newPolygonList.forEach(function (e) {
            return e.setMap(null);
          }), r.forEach(function (e) {
            return e.setMap(t);
          }));
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          var e = this.props;
          var t = e.gmapData,
              n = e.newPolygonList;
          t && t.setMap(null), n.forEach(function (e) {
            return e.setMap(null);
          });
        }
      }, {
        key: "render",
        value: function render() {
          return null;
        }
      }]);

      return l;
    }(o.Component);

    Object.defineProperty(l, 'contextType', {
      enumerable: !0,
      writable: !0,
      value: d.a
    }), Object.defineProperty(l, 'propTypes', {
      enumerable: !0,
      writable: !0,
      value: {
        gmapData: s.a,
        newPolygonList: i.a.arrayOf(s.b)
      }
    });

    var p = function p() {
      return Object(o.createElement)(d.c.Consumer, null, function (_ref15) {
        var e = _ref15.gmapData,
            t = _ref15.newPolygonList;
        return Object(o.createElement)(l, {
          newPolygonList: t,
          gmapData: e
        });
      });
    };

    n.d(t, 'a', function () {
      return p;
    });
  },,,, function (e, t, n) {
    e.exports = n(27);
  }, function (e, t, n) {
    'use strict';

    Object.defineProperty(t, '__esModule', {
      value: !0
    });
    var o = n(7),
        r = n(8),
        a = n(16);
    var i = o['default'];
    t.Button = i;
    var d = r['default'];
    t.Dropdown = d;
    var s = a['default'];
    t.GeoJsonEditor = s, t['default'] = {
      Button: o['default'],
      Dropdown: r['default'],
      GeoJsonEditor: a['default']
    };
  }]);
});